import { render, staticRenderFns } from "./BCIcon.vue?vue&type=template&id=9987ca78"
import script from "./BCIcon.vue?vue&type=script&lang=js"
export * from "./BCIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports